// extracted by mini-css-extract-plugin
module.exports = {"TopSide":"TopSide-module--TopSide--K_H59","red":"TopSide-module--red--3x3vm"};